// extracted by css-extract-rspack-plugin
export default {"errors":"ygRc0","icon":"HXzgm"};